/* ==========================================================================
   TGR Theme — theme.js
   Handles: Shopify AJAX cart, nav active state, testimonial slider,
            gallery lightbox, newsletter form validation
   ========================================================================== */

/* --------------------------------------------------------------------------
   1. SHOPIFY AJAX CART
   -------------------------------------------------------------------------- */
(function () {
  var cartDrawer   = document.getElementById('cartDrawer');
  var cartOverlay  = document.getElementById('cartOverlay');
  var cartBtn      = document.getElementById('cartBtn');
  var cartClose    = document.getElementById('cartClose');
  var cartBadge    = document.getElementById('cartBadge');
  var cartProducts = document.getElementById('cartProducts');
  var cartFooter   = document.getElementById('cartFooter');

  if (!cartDrawer) return;

  /* ── Open / Close ─────────────────────────────────────── */
  function openCart() {
    cartDrawer.classList.add('cart-drawer--open');
    cartOverlay.classList.add('cart-overlay--open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartDrawer.classList.remove('cart-drawer--open');
    cartOverlay.classList.remove('cart-overlay--open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartBtn)     cartBtn.addEventListener('click', openCart);
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  /* ── Money formatting ─────────────────────────────────── */
  function formatMoney(cents) {
    if (cents === 0) return '$0';
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  /* ── Update badge count ───────────────────────────────── */
  function updateBadge(count) {
    if (!cartBadge) return;
    cartBadge.textContent = count > 0 ? String(count) : '';
    cartBadge.classList.toggle('cart-btn__count--visible', count > 0);
  }

  /* ── Build one product row node safely ────────────────── */
  function buildProductRow(item) {
    var imgUrl = (item.featured_image && item.featured_image.url)
      ? item.featured_image.url
      : (item.image || '');

    var row = document.createElement('div');
    row.className = 'cart-product';

    var imgWrap = document.createElement('div');
    imgWrap.className = 'cart-product__img-wrap';
    if (imgUrl) {
      var img = document.createElement('img');
      img.src     = imgUrl;
      img.alt     = item.product_title;
      img.loading = 'lazy';
      imgWrap.appendChild(img);
    }
    row.appendChild(imgWrap);

    var info = document.createElement('div');
    info.className = 'cart-product__info';

    var top = document.createElement('div');
    top.className = 'cart-product__top';
    var name = document.createElement('span');
    name.className   = 'cart-product__name';
    name.textContent = item.product_title;
    var price = document.createElement('span');
    price.className   = 'cart-product__price';
    price.textContent = formatMoney(item.line_price);
    top.appendChild(name);
    top.appendChild(price);
    info.appendChild(top);

    var controls = document.createElement('div');
    controls.className = 'cart-product__controls';

    var qty = document.createElement('div');
    qty.className = 'cart-product__qty';

    var decBtn = document.createElement('button');
    decBtn.className        = 'cart-product__qty-btn';
    decBtn.dataset.action   = 'dec';
    decBtn.dataset.key      = item.key;
    decBtn.dataset.qty      = String(item.quantity);
    decBtn.setAttribute('aria-label', 'Decrease quantity');
    decBtn.textContent = '\u2212';

    var qtyNum = document.createElement('span');
    qtyNum.className   = 'cart-product__qty-num';
    qtyNum.textContent = String(item.quantity);

    var incBtn = document.createElement('button');
    incBtn.className        = 'cart-product__qty-btn';
    incBtn.dataset.action   = 'inc';
    incBtn.dataset.key      = item.key;
    incBtn.dataset.qty      = String(item.quantity);
    incBtn.setAttribute('aria-label', 'Increase quantity');
    incBtn.textContent = '+';

    qty.appendChild(decBtn);
    qty.appendChild(qtyNum);
    qty.appendChild(incBtn);

    var removeBtn = document.createElement('button');
    removeBtn.className      = 'cart-product__remove';
    removeBtn.dataset.action = 'remove';
    removeBtn.dataset.key    = item.key;
    removeBtn.textContent    = 'Remove';

    controls.appendChild(qty);
    controls.appendChild(removeBtn);
    info.appendChild(controls);
    row.appendChild(info);
    return row;
  }

  /* ── Build subtotal / footer node safely ─────────────── */
  function buildFooter(cart) {
    var frag = document.createDocumentFragment();

    var subtotalWrap = document.createElement('div');
    subtotalWrap.className = 'cart-subtotal';

    var row = document.createElement('div');
    row.className = 'cart-subtotal__row';
    var label = document.createElement('span');
    label.className   = 'cart-subtotal__label';
    label.textContent = 'Subtotal';
    var total = document.createElement('span');
    total.className   = 'cart-subtotal__total';
    total.textContent = formatMoney(cart.total_price);
    row.appendChild(label);
    row.appendChild(total);

    var note = document.createElement('p');
    note.className   = 'cart-subtotal__note';
    note.textContent = 'Taxes and shipping calculated at checkout';

    subtotalWrap.appendChild(row);
    subtotalWrap.appendChild(note);
    frag.appendChild(subtotalWrap);

    var checkoutLink = document.createElement('a');
    checkoutLink.href      = '/checkout';
    checkoutLink.className = 'cart-checkout-btn';
    checkoutLink.textContent = 'Checkout';
    frag.appendChild(checkoutLink);

    return frag;
  }

  /* ── Render cart from Shopify cart JSON ───────────────── */
  function renderCart(cart) {
    updateBadge(cart.item_count);

    if (!cartProducts || !cartFooter) return;

    cartProducts.textContent = '';
    cartFooter.textContent   = '';

    if (cart.items.length === 0) {
      var empty = document.createElement('p');
      empty.className   = 'cart-empty';
      empty.textContent = 'Your cart is empty';
      cartProducts.appendChild(empty);
      return;
    }

    var frag = document.createDocumentFragment();
    cart.items.forEach(function (item) {
      frag.appendChild(buildProductRow(item));
    });
    cartProducts.appendChild(frag);
    cartFooter.appendChild(buildFooter(cart));
  }

  /* ── Fetch cart from Shopify ──────────────────────────── */
  function fetchCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  /* ── Add to cart (called from section buttons) ────────── */
  window.addToCart = function (variantId) {
    return fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function () { return fetchCart(); })
    .then(openCart);
  };

  /* ── Change qty / remove (delegated click) ────────────── */
  if (cartProducts) {
    cartProducts.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;

      var key    = btn.dataset.key;
      var action = btn.dataset.action;
      var qtyEl  = btn.closest('.cart-product').querySelector('.cart-product__qty-num');
      var qty    = qtyEl ? parseInt(qtyEl.textContent, 10) : 0;
      var newQty = action === 'inc' ? qty + 1 : action === 'dec' ? Math.max(0, qty - 1) : 0;

      fetch('/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: key, quantity: newQty })
      }).then(function () { return fetchCart(); });
    });
  }

  /* ── Init: populate badge from server-rendered count ─── */
  updateBadge(window.cartItemCount || 0);
  fetchCart();
})();


/* --------------------------------------------------------------------------
   2. NAVIGATION — active state on scroll
   -------------------------------------------------------------------------- */
(function () {
  var sections   = Array.from(document.querySelectorAll('section[id], footer[id]'));
  var navLinks   = document.querySelectorAll('.nav__link');
  var homeLink   = document.querySelector('.nav__link[href="/"]') ||
                   document.querySelector('.nav__link[href="#"]');
  var footerLink = document.querySelector('.nav__link[href="#footer"]');

  function setActive(link) {
    navLinks.forEach(function (l) { l.classList.remove('nav__link--active'); });
    if (link) link.classList.add('nav__link--active');
  }

  window.addEventListener('scroll', function () {
    var nearBottom = (window.scrollY + window.innerHeight) >= (document.body.scrollHeight - 80);
    if (nearBottom) { setActive(footerLink); return; }

    var scrollY = window.scrollY + 120;
    var active  = null;
    sections.forEach(function (sec) {
      if (sec.offsetTop <= scrollY) active = sec;
    });

    if (!active) {
      setActive(homeLink);
    } else {
      var href = '#' + active.id;
      var link = document.querySelector('.nav__link[href="' + href + '"]');
      setActive(link || null);
    }
  }, { passive: true });
})();


/* --------------------------------------------------------------------------
   3. TESTIMONIALS SLIDER
   -------------------------------------------------------------------------- */
(function () {
  var section = document.getElementById('quote');
  var track   = document.getElementById('quoteTrack');
  if (!section || !track) return;

  var dots       = document.querySelectorAll('#quoteDots .quote__dot');
  var slides     = document.querySelectorAll('.quote__slide');
  var viewport   = track.parentElement;
  var sliderArea = section.querySelector('.quote__slider-area');
  var total      = slides.length;
  var current    = 0;

  function isMobileQuote() {
    return window.matchMedia('(max-width: 1024px)').matches;
  }

  function positionQuoteNav() {
    if (!sliderArea) return;

    if (!isMobileQuote()) {
      sliderArea.style.removeProperty('--quote-nav-top');
      return;
    }

    var slide = slides[current];
    if (!slide) return;

    var areaTop = sliderArea.getBoundingClientRect().top;
    var photo = slide.querySelector('.quote__photo');
    var centerY;

    if (photo) {
      var photoRect = photo.getBoundingClientRect();
      centerY = photoRect.top - areaTop + photoRect.height / 2;
    } else {
      centerY = viewport.getBoundingClientRect().top - areaTop + viewport.offsetHeight / 2;
    }

    sliderArea.style.setProperty('--quote-nav-top', centerY + 'px');
  }

  function setViewportHeight() {
    if (!viewport || !slides[current]) return;
    viewport.style.height = slides[current].offsetHeight + 'px';
    requestAnimationFrame(positionQuoteNav);
  }

  function updateSlideLayout() {
    if (isMobileQuote()) {
      track.style.transform = 'none';
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });
      requestAnimationFrame(setViewportHeight);
      return;
    }

    slides.forEach(function (slide) {
      slide.classList.remove('is-active');
    });
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    setViewportHeight();
  }

  function goTo(index) {
    current = (index + total) % total;
    dots.forEach(function (d, i) { d.classList.toggle('active', i === current); });
    updateSlideLayout();
  }

  var prevBtn = document.querySelector('.quote__nav--prev');
  var nextBtn = document.querySelector('.quote__nav--next');
  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

  dots.forEach(function (d) {
    d.addEventListener('click', function () { goTo(+d.dataset.index); });
  });

  section.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft')  goTo(current - 1);
    if (e.key === 'ArrowRight') goTo(current + 1);
  });

  goTo(0);
  slides.forEach(function (slide) {
    var img = slide.querySelector('.quote__avatar');
    if (img && !img.complete) img.addEventListener('load', setViewportHeight);
  });
  window.addEventListener('resize', updateSlideLayout);
  window.addEventListener('load', updateSlideLayout);
  window.matchMedia('(max-width: 1024px)').addEventListener('change', updateSlideLayout);
})();


/* --------------------------------------------------------------------------
   4. LIGHTBOX — gallery photos
   -------------------------------------------------------------------------- */
(function () {
  var lightbox = document.getElementById('lightbox');
  var lbImg    = document.getElementById('lightboxImg');
  var lbClose  = document.getElementById('lightboxClose');
  var lbPrev   = document.getElementById('lightboxPrev');
  var lbNext   = document.getElementById('lightboxNext');
  if (!lightbox) return;

  var photos  = [];
  var current = 0;

  function open(photoSet, index) {
    photos  = photoSet;
    if (!photos.length) return;
    current = ((index % photos.length) + photos.length) % photos.length;
    lbImg.src = photos[current].src;
    lbImg.alt = photos[current].alt || '';
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    lbPrev.style.display = photos.length < 2 ? 'none' : '';
    lbNext.style.display = photos.length < 2 ? 'none' : '';
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function navigate(dir) {
    current = ((current + dir) + photos.length) % photos.length;
    lbImg.src = photos[current].src;
    lbImg.alt = photos[current].alt || '';
  }

  document.addEventListener('click', function (e) {
    var img = e.target.closest('.gallery__photo-img');
    if (img && img.src) {
      var set = Array.from(document.querySelectorAll('.gallery__photo-img'));
      open(set, set.indexOf(img));
    }
  });

  lbClose.addEventListener('click', closeLightbox);
  lbPrev.addEventListener('click',  function () { navigate(-1); });
  lbNext.addEventListener('click',  function () { navigate(1);  });
  lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });

  document.addEventListener('keydown', function (e) {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape')     closeLightbox();
    if (e.key === 'ArrowLeft')  navigate(-1);
    if (e.key === 'ArrowRight') navigate(1);
  });
})();


/* --------------------------------------------------------------------------
   5. ABOUT VIDEO — inline YouTube playback
   -------------------------------------------------------------------------- */
(function () {
  document.querySelectorAll('.about__yt-link[data-youtube-id]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-youtube-id');
      var container = btn.closest('.about__video');
      if (!id || !container) return;

      var iframe = document.createElement('iframe');
      iframe.className = 'about__iframe';
      iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
      iframe.title = btn.getAttribute('aria-label') || 'Video player';
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');

      container.innerHTML = '';
      container.appendChild(iframe);
    });
  });
})();


/* --------------------------------------------------------------------------
   6. NEWSLETTER FORM — Klaviyo list signup
   -------------------------------------------------------------------------- */
(function () {
  var form    = document.getElementById('newsletter-form');
  var input   = document.getElementById('newsletter-email');
  var submit  = document.getElementById('newsletter-submit');
  var errorEl = document.getElementById('newsletter-error');
  var success = document.getElementById('newsletter-success');
  if (!form) return;

  var defaultError = 'Please enter a valid email address.';
  var configError  = 'Newsletter signup is not configured yet.';
  var submitError  = 'Something went wrong. Please try again.';

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());
  }

  function clearError() {
    if (input)   input.classList.remove('signup-form__input--error');
    if (errorEl) {
      errorEl.textContent = defaultError;
      errorEl.classList.remove('signup-form__error--visible');
    }
  }

  function showError(message) {
    if (input)   input.classList.add('signup-form__input--error');
    if (errorEl) {
      errorEl.textContent = message || defaultError;
      errorEl.classList.add('signup-form__error--visible');
    }
  }

  function showSuccess() {
    form.style.display = 'none';
    if (errorEl) errorEl.classList.remove('signup-form__error--visible');
    if (success) success.classList.add('signup-form__success--visible');
  }

  if (input) input.addEventListener('input', clearError);

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var email = input ? input.value.trim() : '';
    if (!isValidEmail(email)) {
      showError(defaultError);
      return;
    }

    var listId    = form.dataset.klaviyoListId;
    var companyId = form.dataset.klaviyoCompanyId;
    if (!listId || !companyId) {
      showError(configError);
      return;
    }

    clearError();
    if (submit) {
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
    }

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Generosity newsletter band',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'revision': '2024-07-15'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (res.ok || res.status === 202) {
          showSuccess();
          form.reset();
          return;
        }
        showError(submitError);
      })
      .catch(function () {
        showError(submitError);
      })
      .finally(function () {
        if (submit) {
          submit.disabled = false;
          submit.removeAttribute('aria-busy');
        }
      });
  });
})();
